import httpClient from '../utils/httpClient';

const API_URL = process.env.VUE_APP_API_BASE_URL;

class UserService {
  getUsers = () => httpClient.get(`${API_URL}/users`);

  createUser = (user) => httpClient.post(`${API_URL}/users/create`, user);

  updateUser = (user) => httpClient.put(`${API_URL}/users/${user.userId}`);

  deleteUser = (user) => httpClient.delete(`${API_URL}/users/${user.userId}`);

  generateRandomPassword = (length) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890!@#$%^&*()_{}()[]';
    const charLength = characters.length;
    for (let i = 0; i < length; i) {
      result += characters.charAt(Math.floor(Math.random() * charLength));
    }

    return result;
  };
}

export default new UserService();
